// import React from 'react';

// const LoadingSpinner = ({ size = 'md', className = '' }) => {
//   const sizeClasses = {
//     sm: 'w-4 h-4',
//     md: 'w-8 h-8',
//     lg: 'w-12 h-12',
//     xl: 'w-16 h-16'
//   };

//   return (
//     <div className={`flex justify-center items-center ${className}`}>
//       <div className={`animate-spin rounded-full border-4 border-gray-300 border-t-blue-600 ${sizeClasses[size]}`}></div>
//     </div>
//   );
// };

// export const LoadingCard = () => (
//   <div className="bg-white rounded-lg shadow-md p-6 animate-pulse">
//     <div className="h-48 bg-gray-200 rounded-lg mb-4"></div>
//     <div className="space-y-3">
//       <div className="h-4 bg-gray-200 rounded w-3/4"></div>
//       <div className="h-4 bg-gray-200 rounded w-1/2"></div>
//       <div className="h-4 bg-gray-200 rounded w-full"></div>
//     </div>
//   </div>
// );

// export const LoadingArticle = () => (
//   <div className="max-w-4xl mx-auto px-4 py-8 animate-pulse">
//     <div className="h-8 bg-gray-200 rounded w-3/4 mb-4"></div>
//     <div className="flex items-center space-x-4 mb-6">
//       <div className="h-4 bg-gray-200 rounded w-24"></div>
//       <div className="h-4 bg-gray-200 rounded w-32"></div>
//     </div>
//     <div className="h-64 bg-gray-200 rounded-lg mb-6"></div>
//     <div className="space-y-4">
//       <div className="h-4 bg-gray-200 rounded w-full"></div>
//       <div className="h-4 bg-gray-200 rounded w-5/6"></div>
//       <div className="h-4 bg-gray-200 rounded w-4/5"></div>
//     </div>
//   </div>
// );

// export default LoadingSpinner;

import React from 'react';

const LoadingSpinner = ({ size = 'md', className = '' }) => {
  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-8 h-8',
    lg: 'w-12 h-12',
    xl: 'w-16 h-16'
  };

  return (
    <div className={`flex justify-center items-center ${className}`}>
      <div className={`animate-spin rounded-full border-4 border-slate-300 border-t-red-600 ${sizeClasses[size]}`}></div>
    </div>
  );
};

export const LoadingCard = () => (
  <div className="bg-white rounded-lg shadow-md p-6 animate-pulse border border-slate-200">
    <div className="h-48 bg-gradient-to-r from-slate-200 to-slate-300 rounded-lg mb-4"></div>
    <div className="space-y-3">
      <div className="h-4 bg-gradient-to-r from-slate-200 to-slate-300 rounded w-3/4"></div>
      <div className="h-4 bg-gradient-to-r from-slate-200 to-slate-300 rounded w-1/2"></div>
      <div className="h-4 bg-gradient-to-r from-slate-200 to-slate-300 rounded w-full"></div>
    </div>
    <div className="mt-4 flex justify-between items-center">
      <div className="h-3 bg-gradient-to-r from-red-200 to-red-300 rounded w-20"></div>
      <div className="h-3 bg-gradient-to-r from-blue-200 to-blue-300 rounded w-24"></div>
    </div>
  </div>
);

export const LoadingArticle = () => (
  <div className="max-w-4xl mx-auto px-4 py-8 animate-pulse">
    {/* Titre */}
    <div className="h-8 bg-gradient-to-r from-slate-200 to-slate-300 rounded w-3/4 mb-4"></div>
    
    {/* Métadonnées */}
    <div className="flex items-center space-x-4 mb-6">
      <div className="h-4 bg-gradient-to-r from-red-200 to-red-300 rounded w-24"></div>
      <div className="h-4 bg-gradient-to-r from-blue-200 to-blue-300 rounded w-32"></div>
      <div className="h-4 bg-gradient-to-r from-slate-200 to-slate-300 rounded w-20"></div>
    </div>
    
    {/* Image principale */}
    <div className="h-64 bg-gradient-to-r from-slate-200 via-slate-300 to-slate-200 rounded-lg mb-6 border border-slate-200"></div>
    
    {/* Contenu de l'article */}
    <div className="space-y-4">
      <div className="h-4 bg-gradient-to-r from-slate-200 to-slate-300 rounded w-full"></div>
      <div className="h-4 bg-gradient-to-r from-slate-200 to-slate-300 rounded w-5/6"></div>
      <div className="h-4 bg-gradient-to-r from-slate-200 to-slate-300 rounded w-4/5"></div>
      <div className="h-4 bg-gradient-to-r from-slate-200 to-slate-300 rounded w-full"></div>
      <div className="h-4 bg-gradient-to-r from-slate-200 to-slate-300 rounded w-3/4"></div>
    </div>
    
    {/* Séparateur */}
    <div className="my-6 border-t border-slate-200"></div>
    
    {/* Paragraphe supplémentaire */}
    <div className="space-y-4">
      <div className="h-4 bg-gradient-to-r from-slate-200 to-slate-300 rounded w-full"></div>
      <div className="h-4 bg-gradient-to-r from-slate-200 to-slate-300 rounded w-4/5"></div>
      <div className="h-4 bg-gradient-to-r from-slate-200 to-slate-300 rounded w-5/6"></div>
    </div>
  </div>
);

export const LoadingList = () => (
  <div className="space-y-4">
    {[1, 2, 3, 4, 5].map((item) => (
      <div key={item} className="bg-white rounded-lg shadow-md p-4 animate-pulse border border-slate-200">
        <div className="flex space-x-4">
          <div className="w-20 h-20 bg-gradient-to-r from-slate-200 to-slate-300 rounded-lg flex-shrink-0"></div>
          <div className="flex-1 space-y-2">
            <div className="h-4 bg-gradient-to-r from-slate-200 to-slate-300 rounded w-3/4"></div>
            <div className="h-3 bg-gradient-to-r from-slate-200 to-slate-300 rounded w-1/2"></div>
            <div className="flex space-x-2">
              <div className="h-3 bg-gradient-to-r from-red-200 to-red-300 rounded w-16"></div>
              <div className="h-3 bg-gradient-to-r from-blue-200 to-blue-300 rounded w-20"></div>
            </div>
          </div>
        </div>
      </div>
    ))}
  </div>
);

export const LoadingHero = () => (
  <div className="relative h-96 bg-gradient-to-r from-slate-200 via-slate-300 to-slate-200 rounded-lg animate-pulse border border-slate-200">
    <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent rounded-lg"></div>
    <div className="absolute bottom-8 left-8 right-8 space-y-4">
      <div className="h-8 bg-white/20 rounded w-3/4"></div>
      <div className="h-4 bg-white/20 rounded w-1/2"></div>
      <div className="flex space-x-4">
        <div className="h-3 bg-red-400/40 rounded w-20"></div>
        <div className="h-3 bg-blue-400/40 rounded w-24"></div>
      </div>
    </div>
  </div>
);

export const LoadingCategory = () => (
  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
    {[1, 2, 3, 4, 5, 6].map((item) => (
      <div key={item} className="bg-white rounded-lg shadow-md overflow-hidden animate-pulse border border-slate-200">
        <div className="h-48 bg-gradient-to-r from-slate-200 to-slate-300"></div>
        <div className="p-4 space-y-3">
          <div className="h-4 bg-gradient-to-r from-slate-200 to-slate-300 rounded w-3/4"></div>
          <div className="h-3 bg-gradient-to-r from-slate-200 to-slate-300 rounded w-1/2"></div>
          <div className="flex justify-between items-center">
            <div className="h-3 bg-gradient-to-r from-red-200 to-red-300 rounded w-16"></div>
            <div className="h-3 bg-gradient-to-r from-blue-200 to-blue-300 rounded w-20"></div>
          </div>
        </div>
      </div>
    ))}
  </div>
);

export const LoadingFullPage = () => (
  <div className="min-h-screen bg-slate-50 animate-pulse">
    {/* Header */}
    <div className="bg-white border-b border-slate-200 p-4">
      <div className="container mx-auto">
        <div className="flex justify-between items-center">
          <div className="h-8 bg-gradient-to-r from-red-200 to-blue-200 rounded w-48"></div>
          <div className="flex space-x-4">
            <div className="h-6 bg-gradient-to-r from-slate-200 to-slate-300 rounded w-20"></div>
            <div className="h-6 bg-gradient-to-r from-slate-200 to-slate-300 rounded w-24"></div>
            <div className="h-6 bg-gradient-to-r from-slate-200 to-slate-300 rounded w-20"></div>
          </div>
        </div>
      </div>
    </div>
    
    {/* Main Content */}
    <div className="container mx-auto px-4 py-8">
      <LoadingHero />
      <div className="mt-8">
        <LoadingCategory />
      </div>
    </div>
  </div>
);

export default LoadingSpinner;